import { render, staticRenderFns } from "./ms-frequency.vue?vue&type=template&id=5c2d487c&scoped=true"
import script from "./ms-frequency.vue?vue&type=script&lang=js"
export * from "./ms-frequency.vue?vue&type=script&lang=js"
import style0 from "./ms-frequency.vue?vue&type=style&index=0&id=5c2d487c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2d487c",
  null
  
)

export default component.exports